import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle, Clock, PoundSterling, Star } from "lucide-react";

const HeroSection = ({ onGetEstimate }) => (
  <section className="relative bg-gradient-to-br from-stone-100 to-stone-200 py-20 md:py-32 overflow-hidden">
    <div className="absolute inset-0 opacity-5">
      <div className="absolute inset-0" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920')", backgroundSize: "cover", backgroundPosition: "center" }}></div>
    </div>
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 relative">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <p className="text-sm font-medium tracking-wide uppercase text-amber-700 animate-fade-in-up">
              Surrey and SW London Trusted Builder
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-none text-slate-900 animate-fade-in-up animation-delay-100">
              Quality Carpentry &
              <span className="text-amber-700"> Construction</span>
            </h1>
            <p className="text-lg leading-relaxed text-stone-600 max-w-xl animate-fade-in-up animation-delay-200">
              From loft conversions to bespoke kitchens, we deliver exceptional 
              craftsmanship with over 10 years of experience. Fully insured with 
              free estimates.
            </p>
          </div>

          <div className="flex flex-wrap gap-6 animate-fade-in-up animation-delay-300">
            <div className="flex items-center gap-2 text-stone-600">
              <CheckCircle size={20} className="text-green-600" />
              <span className="text-sm font-medium">Fully Insured</span>
            </div>
            <div className="flex items-center gap-2 text-stone-600">
              <Clock size={20} className="text-amber-600" />
              <span className="text-sm font-medium">On-Time Delivery</span>
            </div>
            <div className="flex items-center gap-2 text-stone-600">
              <PoundSterling size={20} className="text-slate-600" />
              <span className="text-sm font-medium">Competitive Pricing</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-400">
            <Button
              onClick={onGetEstimate}
              className="bg-amber-700 text-white hover:bg-amber-600 h-14 px-10 font-bold shadow-lg shadow-amber-900/20 transition-all hover:-translate-y-0.5 text-base rounded-md"
              data-testid="hero-get-quote-btn"
            >
              Get Free Estimate
              <ArrowRight className="ml-2" size={20} />
            </Button>
            <Link to="/services">
              <Button
                variant="outline"
                className="h-14 px-8 font-semibold border-2 border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white"
                data-testid="hero-services-btn"
              >
                View Our Services
              </Button>
            </Link>
          </div>
        </div>

        <div className="hidden lg:block relative">
          <img
            src="/images/projects/Extension2.JPG"
            alt="Professional carpentry work"
            className="rounded-lg shadow-2xl shadow-stone-400/30 object-cover w-full h-[500px]"
            width={600}
            height={500}
            loading="eager"
            decoding="async"
            fetchpriority="high"
          />
          <div className="absolute -bottom-6 -left-6 bg-white rounded-lg p-6 shadow-xl">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center">
                <Star className="text-amber-600" size={28} />
              </div>
              <div>
                <p className="text-3xl font-black text-slate-900">5.0</p>
                <p className="text-sm text-stone-500">Customer Rating</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
